export enum actionTypes {
  REQUEST_COMPANY_SETTINGS = "request_company_settings",
  RECEIVE_COMPANY_SETTINGS = "receive_company_settings"
}